import { gameApi } from '@/helpers/api'
import { defineStore } from 'pinia'

interface IServerStatus {
  index: number
  value: number
}

export interface IWorldStatus {
  worldId: number
  worldName: string
  logins: IServerStatus[]
  games: IServerStatus[]
  hubs: IServerStatus[]
  logDate: string
}
function getPropsToArray(obj: object, prefix: string) {
  let index = 0
  const result = [] as IServerStatus[]
  while (true) {
    const key = `${prefix}${index.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}`
    if (!obj.hasOwnProperty(key)) return result
    const value = obj[key as keyof object]
    if (value === -1) return result
    result.push({ index, value })
    index++
  }
}
export const useServerStatusStore = defineStore('serverStatus', {
  state: () => ({
    servers: [] as IWorldStatus[],
  }),
  actions: {
    async fetch(region: string) {
      const {
        data: { servers },
      } = await gameApi.get(`server-status/${region}`)
      this.servers = servers
        .filter((x: any) => !!x.logDate)
        .map((x: any) => ({
          worldId: x.worldId,
          worldName: x.worldName,
          logDate: x.logDate,
          logins: getPropsToArray(x, 'login'),
          games: getPropsToArray(x, 'game'),
          hubs: getPropsToArray(x, 'hub'),
        }))
    },
  },
})
